// extracted by mini-css-extract-plugin
export var active = "simple-tab-module--active--dcjQ4";
export var hidden = "simple-tab-module--hidden--xELDk";
export var tabs = "simple-tab-module--tabs--tXejZ";